import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const COMMITMENTS_ASSIGNMENTS_LIST_QUERY_KEY = 'commitments-assignments-list';

export const getCommitmentsAssignmentsListQueryKey = () =>
  [COMMITMENTS_ASSIGNMENTS_LIST_QUERY_KEY] as const;

const getAssignmentsQueryOptions = ({ enabled }: { enabled: boolean }) =>
  queryOptions({
    queryKey: [COMMITMENTS_ASSIGNMENTS_LIST_QUERY_KEY],
    queryFn: async () => {
      const { data } = await apiClient.commitments.getAssignments();
      return data.commitmentsAssignments ?? [];
    },
    enabled,
  });

export const useAssignmentsQuery = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { isLoading, data, isError, error, refetch } = useQuery(
    getAssignmentsQueryOptions({ enabled })
  );

  return {
    isLoading,
    data,
    isError,
    error,
    refetch,
  };
};
